import React, { Component } from 'react';
import { AppShell } from './AppShell';
import { Redirect, withRouter } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import * as authService from '../services/auth/authService';
import { readLegacyCompatSession } from '../services/legacy/legacySession';

const PUBLIC_PATHS = ['/'];

function isPublicPath(pathname) {
  return PUBLIC_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`));
}

function resolveAlumnoCodigos(authAlumnoCodigos) {
  const fromContext = (authAlumnoCodigos || '').split(',').filter(Boolean);
  if (fromContext.length > 0) {
    return fromContext;
  }

  const legacy = readLegacyCompatSession();
  return (legacy.alumnoCodigos || '').split(',').filter(Boolean);
}

function isSessionAuthenticated(auth) {
  return Boolean(auth?.isAuthenticated || authService.isAuthenticated());
}

export class LayoutInner extends Component {
  static displayName = LayoutInner.name;
  static contextType = AuthContext;

  componentDidMount() {
    this.authenticatedHandler = () => {
      this.forceUpdate();
    };
    window.addEventListener('authenticated', this.authenticatedHandler);
    window.addEventListener('logout', this.authenticatedHandler);
  }

  componentWillUnmount() {
    window.removeEventListener('authenticated', this.authenticatedHandler);
    window.removeEventListener('logout', this.authenticatedHandler);
  }

  render() {
    const auth = this.context || { isAuthenticated: false, alumnoCodigos: '', sessionReady: false };
    const pathname = this.props.location?.pathname || '/';
    const sessionAuthenticated = isSessionAuthenticated(auth);
    const alumnoCodigos = resolveAlumnoCodigos(auth.alumnoCodigos);

    if (!auth.sessionReady && !sessionAuthenticated) {
      if (isPublicPath(pathname)) {
        return <>{this.props.children}</>;
      }
      return <div className="app-shell__content">Cargando...</div>;
    }

    if (!sessionAuthenticated) {
      if (!isPublicPath(pathname)) {
        return <Redirect to="/" />;
      }
      return <>{this.props.children}</>;
    }

    const isStaff = alumnoCodigos.length === 1 && alumnoCodigos[0] === '-1';

    return (
      <div>
        <AppShell variant={isStaff ? 'admin' : 'student'}>
          {this.props.children}
        </AppShell>
      </div>
    );
  }
}

export const Layout = withRouter(LayoutInner);
